import { ReactNode } from 'react'
import { IncidentReport, IncidentStatus } from '@lmc/ts-common'
import dayjs from 'dayjs'

type ViewCaseItem = { key: string; label: ReactNode; children: ReactNode }

export const tagColorMap = {
  [IncidentStatus.closed]: undefined,
  [IncidentStatus.needsReview]: 'red',
  [IncidentStatus.open]: 'blue',
}

export const filterItems = (items: ViewCaseItem[]) => {
  return items?.filter(
    (item) => item.children !== null && item.children !== undefined
  )
}

export const getCombinedTimeIso = (
  dateValue: dayjs.Dayjs,
  timeValue: dayjs.Dayjs
) => {
  const datePart = dayjs(dateValue).format('YYYY-MM-DD')
  const timePart = dayjs(timeValue).format('HH:mm:ss')
  return dayjs(`${datePart}T${timePart}`).toISOString()
}

export const containsImageExtension = (url: string) => {
  return /\.(jpg|jpeg|png|gif)/i.test(url)
}

export const getPdfTitle = (
  incidentReport: IncidentReport,
  incidentCaseString: string
) => {
  return `${incidentReport.serviceUser.name}'s ${incidentReport.log.title} ${incidentCaseString}`
}
